import React, { memo, useCallback, useMemo } from "react";
import Loader from "components/loader";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import TabPanel from "components/common/tab-panel";
import PropTypes from "prop-types";
import { NAVIGATION_TABS } from "components/ebook-reader/ebook-reader.utils";
import { useTranslation } from "react-i18next";


const ChaptersTabPanel = memo((props) => {
    const { activeTab, isLoading, items, handleNavItemClick, classes } = props;
    const { t } = useTranslation();
    const tab = useMemo(() => NAVIGATION_TABS.chapters, []);

    const indent = useCallback((item) => {
        return item?.level ? '\u00A0\u00A0\u00A0\u00A0'.repeat(item.level) : '';
    }, []);

    return (
        <TabPanel key={tab} value={activeTab} index={tab} className={classes.tabPanel}>
            {isLoading && <Loader/>}
            {!items?.length ? (
              <>
                <Typography noWrap className={classes.emptyMessageTitle}>
                  {t('ebook_no_toc_title')}
                </Typography>
                <Typography noWrap className={classes.emptyMessageSubtitle}>
                  {t('ebook_no_toc_subtitle')}
                </Typography>
              </>
            ): (
                <List>
                    {items.map((item) => (
                        <ListItem
                            button
                            key={item.id}
                            className={classes.navItem}
                            onClick={handleNavItemClick(item.selector)}
                        >
                            <Typography className={classes.navItemTitle}>
                                {indent(item)}{item.title}
                            </Typography>
                            {item.page && <Typography noWrap className={classes.navItemSubTitle}>
                                {indent(item)}{t('generic_format_page', { arg: item.page })}
                            </Typography>}
                        </ListItem>
                    ))}
                </List>
            )}
        </TabPanel>
    )
});

ChaptersTabPanel.propTypes = {
    activeTab: PropTypes.oneOf(Object.keys(NAVIGATION_TABS)).isRequired,
    isLoading: PropTypes.bool.isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        title: PropTypes.string,
        selector: PropTypes.object,
    })).isRequired,
    handleNavItemClick: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        tabPanel: PropTypes.string,
        navItem: PropTypes.string,
        navItemTitle: PropTypes.string,
    }),
}

export default ChaptersTabPanel;
